import React, { useState } from "react";
import { DirectUploadProvider } from "react-activestorage-provider";
import { Api } from "../../../../services/config/request";
import SpinnerCircular from "sushiweb/Spinner/SpinnerCircular";
import PropTypes from "prop-types";

const GetDirectUploadPath = (type, driverId) => {
  return Api.url() + `/drivers/${driverId}/documents/${type}`;
};

const DirectUpload = (props) => {
  const {
    onUploadSuccess,
    type,
    directUploadFile,
    handleDirectUploadFailure,
    driverId,
  } = props;
  const [uploaded, setUploaded] = useState(false);
  return (
    <React.Fragment>
      <DirectUploadProvider
        headers={Api.headers()}
        directUploadsPath={GetDirectUploadPath(type, driverId)}
        onSuccess={(res) => {
          setUploaded(true);
          onUploadSuccess(res[0]);
        }}
        render={({ handleUpload, uploads, ready }) => {
          if (ready && !uploaded) {
            handleUpload([directUploadFile]);
          }
          return (
            <div>
              {uploads.map((upload) => {
                switch (upload.state) {
                  case "waiting":
                    return <p key={upload.id}>Waiting to upload</p>;
                  case "uploading":
                    return (
                      <p key={upload.id}>
                        <SpinnerCircular size={"small"} />
                        {Math.floor(upload.progress)}%
                      </p>
                    );
                  case "error": {
                    handleDirectUploadFailure(type, upload.error);
                    return (
                      <p key={upload.id}>Error uploading: {upload.error}</p>
                    );
                  }
                }
              })}
            </div>
          );
        }}
      />
    </React.Fragment>
  );
};

DirectUpload.propTypes = {
  onUploadSuccess: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  directUploadFile: PropTypes.any.isRequired,
  handleDirectUploadFailure: PropTypes.func.isRequired,
  driverId: PropTypes.string.isRequired,
};

export default DirectUpload;
